module.exports = __webpack_public_path__ + "static/media/3.ef4f4dbd.jpg";